module.exports = __webpack_public_path__ + "static/media/0022_IMG_LE_SOL_MEGALITH_MEGABLACK.bd33e5a2.webp";